export default function uppercase (input) {
  if (input && input.length > 0) {
    return input.toUpperCase();
  } else {
    return ''
  }
}
